import {Component, Prop, Vue} from "vue-property-decorator";
import EventBus from "../../helpers/eventbus";
import BrowserStorage from "../../helpers/browser-storage";

@Component
export default class CookieBanner extends Vue {

    @Prop({type: Boolean, default: true})
    public isProduction!: boolean;

    private cookieNameType = 'hasAnalyticsConsent';
    private trackingAllowed = false;
    private isBot = false;

    public created() {

        this.isBot = /bot|googlebot|crawler|facebookexternalhit|spider|robot|crawling/i.test(navigator.userAgent);

        this.trackingAllowed = (!this.isBot && !this.doNotTrack());

        EventBus.$on('cookieConsent', (payload: any) => {
            if (payload[this.cookieNameType]) {
                this.launch();
            } else {
                this.destroy();
            }
        });
    }

    /**
     * EVERY STATISTICS SCRIPTS COME HERE
     */

    public launch() {
        if (this.isProduction && this.trackingAllowed) {
            /**
             * INSERT ALL TRACKING CODE HERE
             */

            //Google Analytics
            // const script = document.createElement('script');
            // script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            //                 new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            //                 j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            //                 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            //                 })(window,document,'script','dataLayer','GTM-NKXTPX8');`;
            // document.body.appendChild(script);

            // gtag('consent', 'update', {
            //     'ad_storage': 'granted'
            // });

            const script = document.createElement('script');
            script.innerHTML = `window.dataLayer = window.dataLayer || [];
                               function gtag(){dataLayer.push(arguments);}
                               gtag('consent', 'update', {'ad_storage': 'granted'});`;
                               // gtag('js', new Date());
                               // gtag('config', 'UA-61968034-1', {'anonymize_ip': true});`;
            document.body.appendChild(script);
        } else {
            console.log("Tracking not allowed because at least one of the following is true. is Author:" + !this.isProduction + ", do Not Track: " + this.doNotTrack() + ", isBot: "+this.isBot)
        }
    }

    public destroy () {
        // Remove all component-specific Cookies
        console.log("Remove all Google Analytics cookies");
        BrowserStorage.clearCookiesStartWith('_ga');
        BrowserStorage.clearCookiesStartWith('_gid');
    }

    public doNotTrack() {
        const dnt = navigator.doNotTrack || window.doNotTrack;
        const canTrack = (dnt !== null && dnt !== undefined) ? (dnt && dnt !== 'yes' && dnt !== '1') : true;

        return !(canTrack);
    }
}



// WEBPACK FOOTER //
// ./src/components/scripts/tag-manager.ts